<template>
  <div class="ml-16 flex items-center sm:mt-6 sm:ml-0">
    <label class="sm:hidden mr-4 inline-block font-medium">Destination</label>
    <custom-select
      class="select-country-collection"
      placeholder="Destination"
      v-model="destination"
      :options="destinationOptions"
    />
  </div>
</template>

<script>
import CustomSelect from '../../components/core/CustomSelect';
import orderBy from 'lodash/orderBy'

export default {
  components: {
    CustomSelect,
  },
  props: {
    country: {
      type: Object,
      default: null,
    },
    countries: {
        type: Array,
        default: []
    }
  },
  data() {
    let destinationOptions = this.countries.map((_c) => {
      return { label: _c.title, value: _c.slug };
    });
    destinationOptions = orderBy(destinationOptions, ['label'], ['asc'])
    destinationOptions.unshift({ label: 'Anywhere', value: 0 });

    return {
      destinationOptions,
    };
  },
  computed: {
    destination: {
      get() {
        if (this.country) {
          return this.country.value;
        }
        return 0;
      },
      set(val) {
        const country = this.destinationOptions.find((_d) => _d.value === val);
        this.$emit('set-destination', country);
      },
    },
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .select-country-collection ::v-deep div:first-child{
    width: 100%;
  }
}

@media only screen and ( min-width: 1200px ) {
  .select-country-collection ::v-deep ul {
    padding: 0px
  }

  .select-country-collection ::v-deep li {
    margin-bottom: 0px
  }
}
</style>
